export default __webpack_public_path__ + "static/media/oscer-pres-odynophagia.6c5b64e5.svg";